module.exports = __webpack_public_path__ + "static/media/AjusteEstoque3.65505929.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancAjusteEstoque/AjusteEstoque3.png
// module id = 2050
// module chunks = 0